module.exports = __webpack_public_path__ + "c37d00776e8428bdd13e02a83955687f.png";